import { motion } from "framer-motion";
import { FADE_UP_30, VISIBLE, VIEWPORT, TITLE_TRANSITION, EASE } from "@/lib/motion";

const GROUPS = [
  {
    heading: "Ad Platforms",
    items: ["Google Ads", "Meta Ads", "Microsoft (Bing)", "TikTok Ads", "LinkedIn Ads", "DV360", "Programmatic"],
    span: "md:col-span-8",
  },
  {
    heading: "Tracking & Attribution",
    items: ["CAPI", "S2S", "GA4", "UTM taxonomies", "Multi-touch attribution"],
    span: "md:col-span-4",
  },
  {
    heading: "Analytics & BI",
    items: ["Power BI", "Looker Studio", "SEMrush", "Cohort & LTV"],
    span: "md:col-span-5",
  },
  {
    heading: "Lifecycle & MMP",
    items: ["MoEngage", "WhatsApp WAPI", "Adjust", "AppsFlyer", "ASO"],
    span: "md:col-span-4",
  },
  {
    heading: "Leadership",
    items: ["7-person team", "Budget ownership"],
    span: "md:col-span-3",
  },
];

const SkillCard = ({ group: g, index: i }) => (
  <motion.div
    initial={FADE_UP_30}
    whileInView={VISIBLE}
    viewport={VIEWPORT}
    transition={{ duration: 0.9, delay: i * 0.05, ease: EASE }}
    className={`col-span-12 ${g.span} card-tech p-8 md:p-10 group`}
    data-testid={`skills-card-${i}`}
  >
    <div className="flex items-center justify-between">
      <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-laser">
        {String(i + 1).padStart(2, "0")}
      </div>
      <div className="w-6 h-px bg-stroke group-hover:bg-laser transition-colors" />
    </div>
    <h3 className="mt-8 md:mt-12 font-serif font-light text-2xl md:text-3xl text-ink leading-tight">
      {g.heading}
    </h3>
    <ul className="mt-6 flex flex-wrap gap-2">
      {g.items.map((it) => (
        <li key={it} className="font-mono text-[11px] tracking-[0.14em] uppercase text-ink/80 border border-stroke px-3 py-2 group-hover:border-laser/50 transition-colors">
          {it}
        </li>
      ))}
    </ul>
  </motion.div>
);

export default function Skills() {
  return (
    <section id="skills" className="relative container-x py-24 md:py-40" data-testid="skills-section">
      <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-20">
        <div className="col-span-12 md:col-span-4">
          <p className="eyebrow">Toolkit</p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <motion.h2
            initial={FADE_UP_30}
            whileInView={VISIBLE}
            viewport={VIEWPORT}
            transition={TITLE_TRANSITION}
            className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[0.96] tracking-tight text-ink"
            data-testid="skills-title"
          >
            The stack that ships the numbers.
          </motion.h2>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-3 md:gap-4" data-testid="skills-grid">
        {GROUPS.map((g, i) => (
          <SkillCard key={g.heading} group={g} index={i} />
        ))}
      </div>
    </section>
  );
}
